import {address_1337} from './1337.js'
import {address_97} from './97.js'
import {address_421613} from './421613.js'
import {address_1} from './1.js'
import {address_5} from './5.js'
import {address_11155111} from './11155111.js'


console.log(address_1337)
console.log(address_97)
const addresses = {
    "1" : address_1,
    "1337" : address_1337,
    "97" : address_97,
    "421613" : address_421613,
    "5": address_5,
    "11155111": address_11155111
}
export default addresses
console.log(addresses)